import React, { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import "tinymce/tinymce";
import "tinymce/icons/default";
import "tinymce/themes/silver";
import "tinymce/plugins/paste";
import "tinymce/plugins/link";
import "tinymce/plugins/image";
import "tinymce/plugins/table";
import "tinymce/plugins/autoresize";

import "tinymce/plugins/emoticons";
import "tinymce/plugins/advlist";
import "tinymce/plugins/autolink";
import "tinymce/plugins/lists";
import "tinymce/plugins/charmap";
import "tinymce/plugins/print";
import "tinymce/plugins/preview";
import "tinymce/plugins/anchor";
import "tinymce/plugins/searchreplace";
import "tinymce/plugins/visualblocks";
import "tinymce/plugins/code";
import "tinymce/plugins/fullscreen";
import "tinymce/plugins/insertdatetime";
import "tinymce/plugins/media";
import "tinymce/plugins/code";
import "tinymce/plugins/help";
import "tinymce/plugins/wordcount";

import "tinymce/skins/ui/oxide/skin.min.css";
import "tinymce/skins/ui/oxide/content.min.css";

import { Editor } from "@tinymce/tinymce-react";

import { serverUrl } from "../Helpers/Config";
import axios from "axios";
import { tokenAuthorize } from "../Helpers/Common";
import $ from "jquery";
import { removeStrongEm } from "../Helpers/Common";
import { getUserNavigationConfrimPopup } from "../../redux/actions/commonAction";

const DPEditor = ({ content, height = 500, ...props }) => {
  const editorRef = useRef(null);
  const dispatch = useDispatch();
  const handleEditorChange = (content, editor) => {
    let div = removeStrongEm(content);
    props.setContent && props.setContent(div);
    props.valueChanges && props.valueChanges();
  };

  const handlePaste = (e, content) => {
    var bufferText =
      ((e.originalEvent || e).clipboardData || window.clipboardData).getData(
        "text/html"
      ) ||
      ((e.originalEvent || e).clipboardData || window.clipboardData).getData(
        "text/plain"
      );

    e.preventDefault();
    var div;
    if (isValidUrl(bufferText)) {
      div = `<a href=${bufferText} target="_blank" title="Journal">${bufferText}</a>`;
    } else {
      div = `<p>${bufferText}</p>`;
    }
    if (editorRef.current) {
      editorRef.current.focus();
      editorRef.current.selection.setContent(div);
    }
    props.valueChanges && props.valueChanges();
  };
  function isValidUrl(bufferText) {
    try {
      new URL(bufferText);
      return true;
    } catch (e) {
      return false;
    }
  }
  const uploadImageCallBack = (blobInfo, success, failure, progress) => {
    const formData = new FormData();
    formData.append("file", blobInfo.blob());

    axios
      .post(serverUrl.UploadImage, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((resp) => {
        if (resp.status === 200) {
          const imgSrc = serverUrl.Base + resp.data.location;
          success(imgSrc);
        } else {
          failure("Image upload failed. Code: " + resp.status);
        }
      })
      .catch((error) => {
        tokenAuthorize(error?.response?.status);
        failure("Image upload failed.");
      });
  };

  return (
    <div className="h-full">
      <Editor
        onInit={(evt, editor) => (editorRef.current = editor)}
        init={{
          remove_trailing_brs: false,
          relative_urls: false,
          // skin: false,
          // content_css: false,
          content_style: `
  @import url('https://fonts.googleapis.com/css2?family=Oswald&display=swap');

  body {
    font-family: Arial, Helvetica, sans-serif;
  }
    h1 { margin-bottom: 24px; }
    h2 { margin-bottom: 20px; }
    h3 { margin-bottom: 16px; }
    h4 { margin-bottom: 12px; }
    h5 { margin-bottom: 8px; }
    h6 { margin-bottom: 6px; }

    h1, h2, h3, h4, h5, h6 {
      margin-top: 0;
      line-height: 1.3;
    }
`
          ,
          min_height: height,
          autoresize_bottom_margin: 20,
          formats: {
            fontname: {
              inline: "span",
              styles: { "font-family": "%value" }
            },
            fontsize: {
              inline: "span",
              styles: { "font-size": "%value" }
            },
            lineheight: {
              inline: "span",
              styles: { "line-height": "%value" }
            }
          },
          extended_valid_elements: "*[*]",
          verify_html: false,
          cleanup: false,
          plugins: [
            "advcode advlist autolink lists link image charmap print preview anchor",
            "searchreplace visualblocks code fullscreen",
            "insertdatetime media table paste code wordcount emoticons",
            "autoresize",
          ],
          menubar: "false",
          toolbar:
            "undo redo | styleselect | fontsizeselect | fontselect | bold italic forecolor backcolor | " +
            "alignleft aligncenter alignright alignjustify | " +
            "bullist numlist outdent indent | " +
            "link image media emoticons | " +
            "table tabledelete tableprops | " +
            "preview code",
          fontsize_formats:
            "8px 10px 12px 14px 16px 18px 20px 22px 24px 26px 28px 30px 32px 34px 36px",
          font_formats:
            "Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Oswald=oswald; Symbol=symbol; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats",
          image_title: "true",
          image_advtab: "true",
          automatic_uploads: "true",
          file_picker_types: "image",
          images_upload_url: serverUrl.UploadFile,
          images_upload_handler: uploadImageCallBack,
        }}
        value={content}
        onEditorChange={handleEditorChange}
        // onPaste={(e) => handlePaste(e, content)}
        onPasteCapture={handlePaste}
      />
    </div>
  );
};
export default DPEditor;
